import React from 'react'
import { withTheme } from 'styled-components'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import AgeTick from './AgeTick'
import CostTick from './CostTick'
import CustomTooltip from './CustomTooltip'
import YAxisLabel from './YAxisLabel'
import AgeLabel from './AgeLabel'

export default withTheme(({ data, form, yAxisLabel, theme }) => (
  <ResponsiveContainer height={300} width='100%'>
    <LineChart
      data={data}
      margin={{ left: 30, right: 30 }}
    >
      <XAxis
        dataKey='year'
        axisLine={{ stroke: theme.colors.grey5 }}
        tickLine={{ stroke: theme.colors.grey5 }}
        padding={{ left: 40, right: 60 }}
        label={<AgeLabel theme={theme} />}
        tick={<AgeTick theme={theme} />}
      />
      <YAxis
        axisLine={{ stroke: theme.colors.grey5 }}
        tickLine={{ stroke: theme.colors.grey5 }}
        padding={{ top: 70, left: 50 }}
        label={<YAxisLabel lines={yAxisLabel} theme={theme} />}
        tick={<CostTick theme={theme} />}
      />
      <Tooltip content={<CustomTooltip />} />
      <Line
        type='monotone'
        dataKey='value'
        stroke={theme.colors.green}
        strokeWidth={2}
        dot={null}
        activeDot={{ r: 7, fill: theme.colors.green, stroke: theme.colors.white }}
      />
    </LineChart>
  </ResponsiveContainer>
))
